<template>
  <van-popup v-model="popShow" :close-on-click-overlay="true" :position="$store.state.isMirroring ? 'right' : 'left'">
    <div class="setting_drawer" :style="{ paddingTop: `calc(${$store.state.statusBarHeight}px + 0.12rem)` }">
      <!-- 账户安全 -->
      <div class="subtitle">{{ $t('accountSecurity.title') }}</div>
      <div class="drawer_item">
        <div :class="$store.state.isMirroring && 'mirror'" class="item_left">
          <img class="item_icon" src="@/assets/home/icon_id.png" alt="" />
          {{ $t('redesign.userId') }}
        </div>
        <div v-if="$store.state.userInfo && $store.state.userInfo.userId" class="item_right">
          {{ $store.state.userInfo.userId }}
        </div>
      </div>
      <div class="drawer_item" @click="toCheckEmail">
        <div :class="$store.state.isMirroring && 'mirror'" class="item_left">
          <img class="item_icon" src="@/assets/home/icon_email.png" alt="" />
          {{ $t('common.email') }}
        </div>
        <div v-if="$store.state.userInfo && $store.state.userInfo.email" class="item_right email">
          {{ maskEmail($store.state.userInfo.email) }}
        </div>
      </div>
      <div class="drawer_item" @click="toCheckPhone">
        <div :class="$store.state.isMirroring && 'mirror'" class="item_left">
          <img class="item_icon" src="@/assets/home/icon_phone.png" alt="" />
          {{ $t('common.phone') }}
        </div>
        <div v-if="$store.state.userInfo && $store.state.userInfo.phone" class="item_right phone">
          {{ maskPhoneNumber($store.state.userInfo.phone) }}
        </div>
      </div>
      <div class="drawer_item" @click="toPaymentPwd">
        <div :class="$store.state.isMirroring && 'mirror'" class="item_left">
          <img class="item_icon" src="@/assets/home/icon_payment_pwd.png" alt="" />
          {{ $t('accountSecurity.payPwd') }}
        </div>
        <div class="item_right">
          <div class="tag">{{ hasPaymentCode ? $t('redesign.goModify') : $t('redesign.goSet') }}</div>
        </div>
      </div>
      <div class="drawer_item" @click="toLoginPwd">
        <div :class="$store.state.isMirroring && 'mirror'" class="item_left">
          <img class="item_icon" src="@/assets/home/icon_login_pwd.png" alt="" />
          {{ $t('accountSecurity.loginPwd') }}
        </div>
        <div class="item_right">
          <div class="tag">{{ $t('redesign.goModify') }}</div>
        </div>
      </div>
      <!-- 其他 -->
      <div class="subtitle">{{ $t('redesign.other') }}</div>
      <div class="drawer_item" @click="openLanguagePopup">
        <div :class="$store.state.isMirroring && 'mirror'" class="item_left">
          <img class="item_icon" src="@/assets/home/icon_language.png" alt="" />
          {{ $t('common.language') }}
        </div>
        <div class="item_right">{{ languageNameLocal }}</div>
      </div>
      <div v-if="showQuickLogin" class="drawer_item" @click="openQuickLogin">
        <div :class="$store.state.isMirroring && 'mirror'" class="item_left">
          <img class="item_icon" src="@/assets/home/icon_quick_login.png" alt="" />
          {{ $t('account.quickLoginTitle') }}
        </div>
      </div>
      <div class="drawer_item" @click="logout">
        <div :class="$store.state.isMirroring && 'mirror'" class="item_left">
          <img class="item_icon" src="@/assets/home/icon_logout.png" alt="" />
          {{ $t('account.logout') }}
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'HomeSettingDrawer',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    curLanguage: {
      type: String,
      default: 'en'
    },
    showQuickLogin: {
      type: Boolean,
      default: false
    },
    hasPaymentCode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popShow: false,
      languageList: [
        { languageNo: 'en', languageNameLocal: 'English', languageName: 'English' },
        { languageNo: 'hi', languageNameLocal: 'हिन्दी', languageName: 'Hindi' },
        { languageNo: 'ur', languageNameLocal: 'اردو', languageName: 'Urdu' },
        { languageNo: 'ar', languageNameLocal: 'اللغة العربية', languageName: 'Arabic' },
        { languageNo: 'es', languageNameLocal: 'español', languageName: 'Spanish' },
        { languageNo: 'pt', languageNameLocal: 'Português', languageName: 'Portuguese' },
        { languageNo: 'bn', languageNameLocal: 'বাংলা', languageName: 'Bengali' },
        { languageNo: 'fr', languageNameLocal: 'Français', languageName: 'French' },
        { languageNo: 'ru', languageNameLocal: 'Русский', languageName: 'Russian' },
        { languageNo: 'id', languageNameLocal: 'bahasa Indonesia', languageName: 'Indonesian' },
        { languageNo: 'vi', languageNameLocal: 'Tiếng Việt', languageName: 'Vietnamese' },
        { languageNo: 'th', languageNameLocal: 'ภาษาไทย', languageName: 'Thai' },
        { languageNo: 'zh-TW', languageNameLocal: '繁體中文', languageName: 'Chinese Traditional' },
        { languageNo: 'zh-CN', languageNameLocal: '简体中文', languageName: 'Chinese Simplified' },
        { languageNo: 'tr', languageNameLocal: 'Türkçe', languageName: 'Turkish' }
      ]
    }
  },
  watch: {
    value(val) {
      this.popShow = val
    },
    popShow(val) {
      this.$emit('input', val)
    }
  },
  computed: {
    languageNameLocal() {
      const curLanguageItem = this.languageList.find((item) => item.languageNo === this.curLanguage)
      if (curLanguageItem) {
        return curLanguageItem.languageNameLocal
      } else {
        return ''
      }
    }
  },
  methods: {
    openLanguagePopup() {
      this.$emit('openLanguagePopup')
    },
    // 脱敏邮箱
    maskEmail(email) {
      var pattern = /^(.{3})(.*)(@.*)$/
      var match = email.match(pattern)

      if (match) {
        var username = match[1]
        var domain = match[3]

        var maskedMiddleChars = '****'

        var maskedEmail = username + maskedMiddleChars + domain
        return maskedEmail
      } else {
        return email
      }
    },
    // 脱敏手机号
    maskPhoneNumber(phoneNumber) {
      var pattern = /^(.{3})(.*)(.{4})$/
      var match = phoneNumber.match(pattern)

      if (match) {
        var firstTwoDigits = match[1]
        var lastTwoDigits = match[3]

        var maskedMiddleDigits = '****'

        var maskedPhoneNumber = firstTwoDigits + maskedMiddleDigits + lastTwoDigits
        return maskedPhoneNumber
      } else {
        return phoneNumber
      }
    },
    toCheckEmail() {
      this.$emit('openAccountVerifyPopup', {
        isEmail: true
      })
    },
    toCheckPhone() {
      this.$emit('openAccountVerifyPopup', {
        isEmail: false
      })
    },
    toPaymentPwd() {
      this.$emit('openPaymentCodeSetPopup')
    },
    toLoginPwd() {
      this.$emit('openPasswordSetPopup')
    },
    openQuickLogin() {
      this.$emit('openQuickLoginPopup')
    },
    logout() {
      this.$emit('logout')
    }
  }
}
</script>

<style scoped>
.setting_drawer {
  width: 3rem;
  height: 100%;
  background: #fff;
  padding: 0.12rem 0.16rem 0;
  box-sizing: border-box;
  overflow-y: auto;
}

.subtitle {
  display: flex;
  padding: 0.12rem 0 0.04rem;
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 600;
}

.drawer_item {
  width: 100%;
  height: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item_left {
  display: flex;
  align-items: center;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  text-align: left;
}

.item_left.mirror {
  text-align: right;
}

.item_icon {
  width: 0.3rem;
  height: 0.3rem;
  margin-inline-end: 0.12rem;
}

.item_right {
  color: #aaa;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
}

.item_right.email {
  direction: ltr;
}

.item_right.phone {
  direction: ltr;
}

.tag {
  display: flex;
  height: 0.2rem;
  padding: 0 0.08rem;
  align-items: center;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.1rem;
  font-style: normal;
  font-weight: 600;
  border-radius: 0.04rem;
  background: #d6d6d6;
}
</style>

<style>
.van-popup--right,
.van-popup--left {
  height: 100%;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/HomeSettingDrawer.vue